// extracted by css-extract-rspack-plugin
export default {"root":"root-MzlWKF","emoji":"emoji-DCprG5","wave":"wave-Mvc7M6"};